import RemoveCircleOutlineOutlined from '@mui/icons-material/RemoveCircleOutlineOutlined';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { SxProps } from '@mui/system';
import { t } from 'i18next';
import React from 'react';
interface RemoveItemButtonProps {
  action: (event?: React.MouseEvent) => void;
  disabled?: boolean;
  icon?: React.ElementType;
  iconStyles?: SxProps;
  iconDataTestId?: string;
  sx?: SxProps;
  tooltipTitle?: string;
}
const RemoveItemButton = ({
  action,
  disabled,
  icon: Icon = RemoveCircleOutlineOutlined,
  iconStyles,
  iconDataTestId,
  sx,
  tooltipTitle: tooltipTitleProp,
}: RemoveItemButtonProps) => {
  const tooltipTitle = tooltipTitleProp || t('actions.remove');

  return (
    <Box
      sx={{
        zIndex: 2,
        width: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <Tooltip title={tooltipTitle}>
        <Icon
          sx={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.4 : 1,
            backgroundColor: 'background.paper',
            borderRadius: '50%',
            ...iconStyles,
          }}
          onClick={disabled ? undefined : action}
          aria-disabled={disabled ? true : undefined}
          aria-label={t('aria_label.button.remove', {
            name: t('aria_label.common.item'),
          })}
          data-test-id={iconDataTestId}
        />
      </Tooltip>
    </Box>
  );
};
export { RemoveItemButton };
